<template>
    <el-dialog title="添加子类型" :close-on-click-modal="false" :visible.sync="visible" width="500px" :append-to-body="true">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px" :inline="true" class="border-form">
            <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="上级" prop="parentJointName" class="item">
                        <div> {{ parentJointName }} </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="类型名称" prop="kindName" class="item">
                        <el-input class="selItemInput" v-model="dataForm.kindName" placeholder="请输入" clearable
                            style="width:300px">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row class="formBtnGroup">
            <el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">保存</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    name: "file-setting-add-or-update",
    data() {
        return {
            visible: false,
            inline: false,
            action: "",
            kindType: '',
            parentJointName: "",
            dataForm: {
                recId: '',
                kindName: '',
                parentJointName: ''
            },
            dataRule: {
                kindName: [
                    { required: true, message: "请填写类型名称", trigger: "change" }
                ],
            },
        }
    },
    methods: {
        init(recId, kindType) {
            this.visible = true;
            this.kindType = kindType;
            this.dataForm.recId = recId ? recId : 0;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                this.$http({
                    url: this.$store.state.httpUrl + `/business/filekindconfig/getParentJointName/${this.dataForm.recId}`,
                    method: 'get',
                    params: this.$http.adornParams({})
                }).then(({ data }) => {
                    if (data && data.resultCode === 200) {
                        this.parentJointName = data.body;
                        this.dataForm.parentJointName = data.body
                    }
                })
            })
        },
        dataFormSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    let _url = "/business/filekindconfig/save";
                    this.$http({
                        url: this.$store.state.httpUrl + _url,
                        method: "post",
                        data: this.$http.adornData({
                            workNo: $common.getItem("workNo"),
                            kindName: this.dataForm.kindName,
                            kindType: this.kindType,
                            parentId: this.dataForm.recId,
                            defaultFlg: "0"
                        })
                    }).then(({ data }) => {
                        if (data && data.resultCode === 200) {
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.visible = false;
                                     this.$emit("refreshDataList");
                                }
                            });
                        }
                    });
                }
            });
        }

    }
}
</script>
<style scoped>
.item::v-deep .el-form-item__label {
    color: #00428E !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    background-color: #E1F1FF;
    white-space: nowrap !important;
    border-right: solid #dadada 1px;
}

.border-form .el-row.set_border {
    border-bottom: solid #dadada 1px;
    border-left: solid #dadada 1px;
    border-right: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
    border-top: solid #dadada 1px;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}
</style>
